/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* announcment bar */


      $(document).ready(function() {
        
        var slide_speed = $('.AnnouncementBar__Content').attr('data-slide-speed');
        
        setInterval(function() {  
          
          if ($('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_1').hasClass('is-visible')) {

            $('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_1').removeClass('is-visible');

            $('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_2').addClass('is-visible');

            $('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_3').removeClass('is-visible');

          }

          else if ($('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_2').hasClass('is-visible')) {

            $('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_2').removeClass('is-visible');

            $('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_1').removeClass('is-visible');

            $('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_3').addClass('is-visible');

          }

          else if ($('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_3').hasClass('is-visible')) {

            $('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_2').removeClass('is-visible');

            $('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_1').addClass('is-visible');

            $('.AnnouncementBar__Wrapper .AnnouncementBar__Content .announcent_bar_text_3').removeClass('is-visible');

          }
          
        }, slide_speed);

        function ajaxcart_add (){ 
          $('.collection_add_cart .ProductForm:not(.ajax_submit_added)').submit(function(e){
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: $(this).serialize(),
                success: function(){
                  document.dispatchEvent(new CustomEvent('product:added', {
                    bubbles: true,
                    detail: {
                      quantity: 1
                    }
                  }));
                }
            });
          }).addClass('ajax_submit_added');
        };
        ajaxcart_add();

        setInterval(function() {
          if ( $('.collection_add_cart .ProductForm:not(.ajax_submit_added)').length >= 1 ) {
            ajaxcart_add();
          }
        }, 300);
        
        if ( $('.ProductRecommendations , .recent_pro_items').length > 0 && $('.ProductRecommendations>* , .recent_pro_items .ProductListWrapper').length == 0 ) { 
          var pro_recom_interval = setInterval(function() {
            if ( $('.ProductRecommendations>* , .recent_pro_items .ProductListWrapper').length > 0 ) {
              ajaxcart_add(); 
              clearInterval(pro_recom_interval);
            }
          }, 500);
 
        }

        if ( $('.recent_pro_items').length > 0 && $('.recent_pro_items .ProductListWrapper').length == 0 ) { 
          var pro_recom_interval_1 = setInterval(function() {
            if ( $('.recent_pro_items .ProductListWrapper').length > 0 ) {
              ajaxcart_add(); 
              clearInterval(pro_recom_interval_1);
            }
          }, 500);
 
        }

        if ($('table .minus_quantity').next('table .QuantitySelector__CurrentQuantity').val() <= 0 ) {
          $('table .minus_quantity').css("pointer-events","none");
        }

        $('table .minus_quantity').click(function(e) {
          e.preventDefault();
          e.stopPropagation();
          var quantity_value = $(this).next('table .QuantitySelector__CurrentQuantity').val();
          quantity_value = parseInt(quantity_value);
          quantity_value = quantity_value - 1;
          $(this).next('table .QuantitySelector__CurrentQuantity').val(quantity_value);

          var selected_price = parseInt($(this).parents('table').find('.related_pro_price').attr('data-price'));
          var total_selected_price = parseInt($('.Product__Info .ProductMeta__PriceList .ProductMeta__Price').attr('data-total-price')) - selected_price; 
          $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price').attr('data-total-price',total_selected_price);
          $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price').text('€'+(total_selected_price / 100).toFixed(2));
          if( quantity_value <= 0) {
            $(this).css("pointer-events","none");
          }
        });

        $('table .plus_quantity').click(function(e) {
          e.preventDefault();
          e.stopPropagation();
          var quantity_value = $(this).prev('table .QuantitySelector__CurrentQuantity').val();
          quantity_value = parseInt(quantity_value);
          quantity_value = quantity_value + 1;
          $(this).prev('table .QuantitySelector__CurrentQuantity').val(quantity_value);

          var selected_price = parseInt($(this).parents('table').find('.related_pro_price').attr('data-price'));
          var total_selected_price = parseInt($('.Product__Info .ProductMeta__PriceList .ProductMeta__Price').attr('data-total-price')) + selected_price; 
          $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price').attr('data-total-price',total_selected_price);
          $('.Product__Info .ProductMeta__PriceList .ProductMeta__Price').text('€'+(total_selected_price / 100).toFixed(2));
          if( quantity_value > 0) {
            $(this).parents('.QuantitySelector').find('.minus_quantity').css("pointer-events","auto");
          }
        });
        
      });